import { useState } from 'react';
import { useCustomer } from 'hooks';
import fetchJson from 'lib/utils/fetchJson';
import { keys, set } from 'lib/utils/localStorage';
import { useRouter } from 'next/router';
import { addLocaleToHref } from '../../lib/utils/helpers';

export const useLogoutCustomer = locale => {
  const [state, setState] = useState({
    response: null,
    loading: false,
    error: null,
  });

  const { mutateCustomer } = useCustomer();
  const router = useRouter();

  const logoutCustomer = async (accessToken, postLogoutDestination) => {
    if (accessToken) {
      setState({ response: null, loading: true, error: null });
      try {
        const logoutResponse = await fetchJson('/api/shopify/account/logout/', {
          method: 'POST',
          body: JSON.stringify({
            accessToken,
            locale,
            postLogoutDestination,
          }),
        });
        setState({
          response: true,
          loading: false,
          error: null,
        });
        set(keys.LOGGED_IN_CUSTOMER, null);

        if (logoutResponse?.logoutUrl) {
          document.location.href = logoutResponse.logoutUrl;
          return;
        }

        await mutateCustomer(logoutResponse);
        router.push(addLocaleToHref('/', locale));
      } catch (err) {
        setState({
          response: null,
          loading: false,
          error: true,
        });
      }
    } else {
      setState({
        response: null,
        loading: false,
        error: true,
      });
    }
  };
  return [logoutCustomer, state];
};

export default useLogoutCustomer;
